/* Copyright (c) 2020 Paul Nebel */

import React from 'react';
import Slider from 'react-input-slider';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import debounce from '../core/utils/common-functions';

class NumberInput extends React.PureComponent {
    constructor (props, context) {
        super(props, context);

        this.state = {
            name: this.props.name,
            value: this.props.value,
        };

        this.onChange = this.onChange.bind(this);
        this.notifyUpdate = this.notifyUpdate.bind(this);
        this.efficientNotifyUpdate = debounce(this.notifyUpdate, 250).bind(this);
    }

    notifyUpdate(name, value) {
        this.props.notifySettingChanged(name, value);
    }

    onChange({ x }) {
        const {
            name,
        } = this.state;
        const value = x;
        if (value !== this.state.value) {
            this.setState({ value });
            // this.props.notifySettingChanged(name, value);
            this.efficientNotifyUpdate(name, value);
        }
    }

    render() {
        const {
            step,
            min,
            max,
            minIcon,
            maxIcon,
        } = this.props;
        return (
            <div className='columns is-mobile is-gapless'>
                <div className='column is-2 has-text-centered'>
                    <i className={ `fas ${ minIcon } is-size-3` }></i>
                </div>
                <div className='column is-8'>
                    <Slider
                        styles={{
                            track: {
                                backgroundColor: '#3E4B59',
                                width: '100%',
                            },
                            active: {
                                backgroundColor: '#2984D3'
                            },
                        }}
                        axis='x'
                        xstep={ step }
                        xmin={ min }
                        xmax={ max }
                        x={ this.state.value }
                        onChange={ this.onChange }
                    />
                </div>
                <div className='column is-2 has-text-centered'>
                    <i className={ `fas ${ maxIcon } is-size-3` }></i>
                </div>
            </div>
        );
    }
}


NumberInput.propTypes = {
    name: PropTypes.string.isRequired,
    value: PropTypes.number,
    notifySettingChanged: PropTypes.func.isRequired,
    min: PropTypes.number,
    max: PropTypes.number,
    step: PropTypes.number,
    minIcon: PropTypes.string,
    maxIcon: PropTypes.string,
};

NumberInput.defaultProps = {
    name: 'range',
    value: 0.5,
    min: 0,
    max: 1,
    step: 0.1,
    minIcon: 'circle',
    maxIcon: 'circle',
};

const mapDispatchToProps = dispatch => {
    return {
        notifySettingChanged: (
            name,
            value,
        ) => dispatch({
            type: `SETTING_CHANGED`,
            name,
            value,
        }),
    };
};

export default connect(
    null,
    mapDispatchToProps,
)(NumberInput);
